var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    _vm._g(
      _vm._b(
        { class: _vm.containerClass, style: _vm.containerStyle },
        "div",
        _vm.$attrs,
        false
      ),
      _vm.$listeners
    ),
    [
      _c(
        "v-tooltip",
        {
          attrs: { disabled: !_vm.hasTooltip, top: "" },
          scopedSlots: _vm._u([
            {
              key: "activator",
              fn: function(ref) {
                var on = ref.on
                var attrs = ref.attrs
                return [
                  _c(
                    "div",
                    _vm._g(
                      _vm._b(
                        {
                          staticClass: "full-center flex-row",
                          staticStyle: { gap: "6px" }
                        },
                        "div",
                        attrs,
                        false
                      ),
                      on
                    ),
                    [
                      _c("icon-svg", {
                        attrs: {
                          name:
                            _vm.numericValue < 0
                              ? "received-new-ux"
                              : "send-new-ux",
                          size: _vm.small ? 12 : 16
                        }
                      }),
                      _vm._v(" " + _vm._s(_vm.displayValue) + " ")
                    ],
                    1
                  )
                ]
              }
            }
          ])
        },
        [
          _c("span", {
            domProps: {
              innerHTML: _vm._s(_vm.tooltipContent.replace(/\n/g, "<br />"))
            }
          })
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }